import React, { useEffect, useState } from "react";
import { Alert, Button, Card, Flex, Typography } from "antd";
import { GoogleOutlined } from "@ant-design/icons";
import { signIn } from "../lib/auth-client";
import { appName } from "../lib/env";

const { Title, Text } = Typography;

function getAuthError(): string | null {
  const params = new URLSearchParams(window.location.search);
  const error = params.get("error");
  const message = params.get("message");

  if (message) {
    return message;
  }
  if (error) {
    return "Authentication failed. Please try again or contact an administrator.";
  }
  return null;
}

const Login: React.FC = () => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    const msg = getAuthError();
    if (msg) {
      setErrorMessage(msg);
      // Clean error params from URL without reloading
      const url = new URL(window.location.href);
      url.searchParams.delete("error");
      url.searchParams.delete("error_description");
      url.searchParams.delete("message");
      window.history.replaceState({}, "", url.toString());
    }
  }, []);

  const handleGoogleSignIn = async () => {
    setErrorMessage(null);
    await signIn.social({
      provider: "google",
      callbackURL: `${window.location.origin}/`,
      errorCallbackURL: `${window.location.origin}/`,
    });
  };

  return (
    <Flex justify="center" align="center" style={{ minHeight: "100vh" }}>
      <Card style={{ width: 400, textAlign: "center" }}>
        <Title level={3} style={{ marginBottom: 8 }}>
          {appName}
        </Title>
        <Text type="secondary" style={{ display: "block", marginBottom: 24 }}>
          Sign in to continue
        </Text>
        {errorMessage && (
          <Alert
            type="error"
            message={errorMessage}
            showIcon
            style={{ marginBottom: 16, textAlign: "left" }}
            closable
            onClose={() => setErrorMessage(null)}
          />
        )}
        <Button
          type="primary"
          size="large"
          block
          onClick={handleGoogleSignIn}
          icon={<GoogleOutlined />}
        >
          Sign in with Google
        </Button>
      </Card>
    </Flex>
  );
};

export default Login;
